export const formatFileSize = (sizeInKB: number): string => {
  const sizeInMB = sizeInKB / 1024;
  return `${sizeInMB} MB`;
};
